import { useNavigate } from '@tanstack/react-router'
import Button from '~components/ui/button'
import Icon from '~components/ui/icon'
import { NOTION_PAGES } from '~constants'
import getRootPath from '~utils/app/get-root-path'
import HeaderBlock from '../../../components/general/header-block'
import { openInPlace } from '~utils/open-external'

const Agreement = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate({
      to: `${getRootPath()}/ask-a-vet/select-pet`,
      resetScroll: true,
    })
  }

  return (
    <main className="flex flex-col items-center min-h-dynamic-screen relative">
      <HeaderBlock />
      <div className="flex flex-col flex-gap-y-4 py-6 px-5 w-full">
        <Icon name="circle_exclamation" className="w-10 h-10 fill-secondary-500" />
        <h2 className="text-gray-900 text-headline-3 whitespace-pre-line md:whitespace-nowrap dark:text-white">{`Things we can't\nprovide in the answer`}</h2>
      </div>
      <div className="flex flex-col flex-gap-y-2 py-4 px-5 w-full [&_*]:text-gray-700 [&_*]:text-body-2">
        <p>We don’t provide any of the following in the answers.</p>
        <ul className="flex flex-col flex-gap-y-1 list-disc pl-2 [&_li]:ml-4">
          <li>
            <span className="text-gray-900">Prescriptions of medicines</span>
          </li>
          <li>
            <span className="text-gray-900">Instructions on prescribed drugs and dosages</span>
          </li>
          <li>
            <span className="text-gray-900">Second opinion</span>
          </li>
          <li>
            <span className="text-gray-900">Recommending vet clinics</span>
          </li>
        </ul>
        <p>
          Our answers are only advice and not medical judgment. Please visit the hospital
          immediately if you’re clearly in an emergency situation.
        </p>
      </div>
      <section className="flex flex-col sticky bottom-0 w-full bg-gradient-to-t from-background dark:from-background dark:to-background/0 from-90% to-background/0 justify-end flex-1">
        <div className="flex flex-col flex-gap-y-4 pb-5 pt-4 w-full">
          <div className="pt-2 pb-4 px-5 w-full">
            <p className="text-body-2 text-gray-400 md:text-center dark:text-gray-600">
              By starting consultation, you agree to{' '}
              <a
                href={NOTION_PAGES.TERMS_OF_SERVICE.appUri}
                onClick={e => {
                  // SmartThings 웹뷰는 target="_blank" 를 열지 않는다. 같은 창으로 연다 (DRT-7239)
                  e.preventDefault()
                  openInPlace(NOTION_PAGES.TERMS_OF_SERVICE.embedUri)
                }}
                className="text-primary-600 underline"
              >
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href={NOTION_PAGES.PRIVACY_POLICY.appUri}
                onClick={e => {
                  // SmartThings 웹뷰는 target="_blank" 를 열지 않는다. 같은 창으로 연다 (DRT-7239)
                  e.preventDefault()
                  openInPlace(NOTION_PAGES.PRIVACY_POLICY.embedUri)
                }}
                className="text-primary-600 underline"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
          <div className="px-5 w-full">
            <Button className="w-full" onClick={handleClick}>
              I understand
            </Button>
          </div>
        </div>
      </section>
    </main>
  )
}

Agreement.displayName = 'AgreementScreen'

export default Agreement
